<template>
  <NuxtLinkLocale
    :to="to"
    class="game_booster_card t-white"
    :class="currentGameSlug"
  >
    <div class="d-flex-row space-between align-start">
      <div class="online_boosters" :class="currentGameSlug" v-if="online"></div>
      <div v-else class=""></div>
      <img
        class="avatar"
        :src="userImage"
        alt="Avatar image"
        style="border-radius: 50%"
      />
      <img
        class="flag_icon"
        alt="Flag Icon"
        :src="flagImage"
        v-if="language?.image"
      />
      <div v-else-if="!language?.image" class=""></div>
    </div>
    <div class="d-flex-row gap-10 flex-wrap">
      <h4 class="t-white body-xl font-family-2 username_text">
        {{ username }}
      </h4>
      <img class="rank_icon" alt="Game Rank Icon" :src="rank" v-if="rank" />
      <img class="rank_icon" alt="Game Rank Icon" :src="tier" v-if="tier" />
    </div>
    <div class="d-flex-row gap-10">
      <div class="booster_rating">
        <star-icon />
        <h4 class="t-white bold-s f-w-600 font-family-1">
          {{ rating }}
        </h4>
      </div>
      <div class="booster_rating">
        <message-icon />
        <h4 class="t-white bold-s f-w-600 font-family-1">
          {{ orders }}
        </h4>
      </div>
    </div>
  </NuxtLinkLocale>
</template>

<script setup>
import StarIcon from "../icons/StarIcon.vue";
import MessageIcon from "../icons/MessageIcon.vue";
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
const { currentGameSlug } = useGameComposable();
const { public: publicConfig } = useRuntimeConfig();
const online = ref(0);
const props = defineProps({
  image: {
    type: String,
    default: "",
  },

  language: {
    default: "",
  },
  rating: {
    type: Number,
    default: 4.9,
  },
  orders: {
    type: Number,
    default: 328,
  },
  isOnline: {
    type: Boolean,
    default: false,
  },
  type: {
    default: false,
  },
  username: {
    type: String,
    default: "",
  },
  rank: {
    type: String,
    default: "",
  },
  tier: {
    type: String,
    default: "",
  },
  to: {
    type: String,
    default: "",
  },
  id: {
    type: Number,
  },
});
const { image, language, rating, orders, type, username, rank, tier, to, id } =
  props;

const userImage = computed(() => {
  if (image.includes(publicConfig.apiBaseUrl)) {
    return image;
  } else return `${publicConfig.apiBaseUrl}${image}`;
});
const flagImage = computed(() => {
  return `/images/flags-language/${language?.image}.svg`;
});

const boosterStatus = async (booster_id) => {
  if (booster_id) {
    window.Echo.private("user-status." + booster_id).listen(
      ".user.status.changed",
      (e) => {
        online.value = e.data.online;
      }
    );
  }
};

onMounted(() => {
  online.value = props.isOnline;

  boosterStatus(props.id);
});

onBeforeUnmount(() => {
  if (props.id) {
    window.Echo.leave("user-status." + id);
  }
});
</script>
